/**
 * Split description for SEO-friendly read-more display.
 * Tries sentence boundaries first, falls back to word boundaries.
 * Uses slicing to preserve original whitespace (including newlines).
 *
 * Extracted from the (now removed) HALO ReadMoreButton primitive during
 * HP-7690's migration to Constellation `ShowHide`.
 */
export function splitDescription(text: string, maxTruncatedLength = 150) {
  if (text.length <= maxTruncatedLength) {
    return { truncated: text, hidden: '' };
  }

  let breakPoint = 0;

  // Try sentence boundaries
  const sentenceEnd = /[.!?](?=\s)/g;
  let match;
  while ((match = sentenceEnd.exec(text)) !== null) {
    const end = match.index + 1;
    if (end > maxTruncatedLength) break;
    breakPoint = end;
  }

  // Fall back to word boundaries
  if (!breakPoint) {
    const space = /\s+/g;
    while ((match = space.exec(text)) !== null) {
      if (match.index > maxTruncatedLength) break;
      if (match.index > 0) breakPoint = match.index;
    }
  }

  if (!breakPoint) breakPoint = maxTruncatedLength;

  const truncated = text.slice(0, breakPoint).trimEnd();
  const hidden = text.slice(breakPoint);

  return { truncated, hidden };
}
